import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useMemo } from "react";

/*
Get Auth token:
- https://help.wialon.com/help/wialon-hosting/en/expert-articles/sdk/intro-to-sdk-basic-requests#IntrotoSDK\:BasicRequests-auth_enObtainingaTokenandAuthorization
- https://hosting.wialon.com/login.html

host: https://hst-api.wialon.com/wialon/ajax.html
base_url: https://hst-api.wialon.com

Login to get eid/sid: {{host}}?svc=token/login&params={"token":"a313517029bd48db6e8d15e25b9e4bc917A1CC23B5E464D924E243CED0DB761BADEEF5F9"}
Search for units: {{base_url}}/wialon/ajax.html?svc=core/search_items&params={"spec":{"itemsType":"avl_unit","propName":"sys_name","propValueMask":"*","sortType":"sys_name"},"force":1,"flags":1,"from":0,"to":0}&sid=02196434221e6215eab72e0d588bc496
Get initial coordinates: https://hst-api.wialon.com/wialon/ajax.html?svc=core/batch&sid=020f122e05b05874bd698efbef6b3fa5&params=[{"svc":"core/update_data_flags","params":{"spec":[{"type":"col","data":["27876962"],"flags":4294967295,"mode":1}]}}]
Get reacurring events with coordinates: {{base_url}}/avl_evts?sid=020c9a9b94989e6fe083ae8b50b9e54a
*/

const mapContainerStyle = {
  width: '100%',
  height: '100%',
};

const MapContainer = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyD4TV67BkLPPGMbnmcLLFqGKpEQ1OX1Y8I",
  });
  const center = useMemo(() => ({ lat: 20.680508, lng: -103.428960 }), []);
  const customMarker = {
    path: "M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759   c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z    M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713   v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336   h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805",
    fillColor: "red",
    fillOpacity: 2,
    strokeWeight: 1,
    rotation: 0,
    scale: 1,
  };

  return (
    <div className="card mb-4">
        <div className="card-body">
          <div className="card-header">
            <h5 className="card-title">Ubicación</h5>
          </div>
          <div className="map-content">
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={12}
        >
          <Marker
            position={{ lat: 20.680508, lng: -103.428960 }}
            icon={customMarker}
          />
        </GoogleMap>
      )}
      </div>
    </div>
  </div>
  );
};

export default MapContainer;
